// extracted by css-extract-rspack-plugin
export default {"spaceXXSmall":"4px","colorBorderDanger":"#e31c4c","timezonePicker":"timezone-picker__timezonePicker___pANrV","error":"timezone-picker__error___Nq5eq"};